import React, { useState, useEffect } from "react";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import Illustration from "../../../../../partials/content/Illustration";
import { getLeadQuotations } from "../../../../../services/crm/leadService";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { Badge } from "react-bootstrap";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import { DialogActions } from "@material-ui/core";
import NumberFormat from "react-number-format";
import { formatDate } from "../../../../../utils/utils";
import { Card } from "primereact/card";
import CustomPrintOutQuotation from "../../../../../partials/content/CustomPrintOutQuotation";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
const LeadQuotations = ({ history, leadID }) => {
  const { reload } = useGlobalData();
  const [auth, setAuth] = useState({});
  const [leadQuotations, setLeadQuotations] = useState([]);
  const [leadQuotation, setLeadQuotation] = useState({});
  const [openQuotationPrint, setOpenQuotationPrint] = useState(false);
  const [salesWon, setSalesWon] = useState(0);
  const [salesLost, setSalesLost] = useState(0);
  const [salesInProgress, setSalesInProgress] = useState(0);

  useEffect(() => {
    getLeadQuotationsData();
  }, [leadID, reload]);

  async function getLeadQuotationsData() {
    const response = await getLeadQuotations(leadID);
    const { data, auth } = response.data;
    setLeadQuotations(data.quotations);
    setAuth(auth);

    const salesWon = data.quotations.filter(
      (quotation) => quotation.salesStatus === 3
    );
    const salesLost = data.quotations.filter(
      (quotation) => quotation.salesStatus === 4
    );
    const salesInProgress = data.quotations.filter(
      (quotation) => quotation.salesStatus === 1
    );
    setSalesWon(salesWon.length);
    setSalesLost(salesLost.length);
    setSalesInProgress(salesInProgress.length);
  }

  const leadQuotationsDetailColumn = [
    {
      header: "Expiry Date",
      field: "expiryDate",
      type: "date",
    },
    {
      header: "Sales Order ID",
      field: "salesOrderCode",
      type: "string",
    },
    {
      header: "Sales Agent",
      field: "salesName",
      type: "string",
    },
    {
      header: "Customer RFQ Number",
      field: "customerRfqNo",
      type: "string",
    },
    {
      header: "Exchange Rate To Base Currency",
      field: "exchangeRate",
      type: "currency",
    },
    {
      header: "Version",
      field: "ver",
      type: "string",
    },
    {
      header: "Approval Status",
      field: "approvalStatusDesc",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card id="overviewcard" className="border-success">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-check-circle kt-font-success" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">SALES WON</div>
                </div>
                <Badge variant="success">{salesWon}</Badge>
              </div>
            </div>
          </Card>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card id="overviewcard" className="border-warning">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-exclamation-circle kt-font-warning" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">IN PROGRESS</div>
                </div>
                <Badge variant="warning">{salesInProgress}</Badge>
              </div>
            </div>
          </Card>
        </div>
        <div className="col-sm-4 col-md-4 col-lg-4">
          <Card id="overviewcard" className="border-danger">
            <div className="kt-widget4">
              <div className="kt-widget4__item ">
                <span className="kt-widget4__icon">
                  <i className="fas fa-times-circle kt-font-danger" />
                </span>
                <div className="kt-widget4__info ">
                  <div className="kt-widget4__highlighttitle">SALES LOST</div>
                </div>
                <Badge variant="danger">{salesLost}</Badge>
              </div>
            </div>
          </Card>
        </div>
      </div>
      {leadQuotations.length ? (
        <React.Fragment>
          <CustomDataTable
            data={leadQuotations}
            dataDetailColumns={leadQuotationsDetailColumn}
            onRefreshData={() => {
              getLeadQuotationsData(leadID);
            }}
            columns={[
              {
                header: "Quotation ID",
                field: "quotationCode",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Quotation Date",
                field: "quotationDate",
                body: (rowData) => formatDate(rowData.quotationDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Quotation Status",
                field: "salesStatus",
                body: (rowData) => {
                  if (rowData.salesStatus === 4) {
                    return (
                      <Badge variant="danger">{rowData.salesStatusDesc}</Badge>
                    );
                  } else if (rowData.salesStatus === 1) {
                    return (
                      <Badge variant="warning">{rowData.salesStatusDesc}</Badge>
                    );
                  } else if (rowData.salesStatus === 3) {
                    return (
                      <Badge variant="success">{rowData.salesStatusDesc}</Badge>
                    );
                  } else {
                    return (
                      <Badge variant="dark">{rowData.salesStatusDesc}</Badge>
                    );
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currency.currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Grand Total",
                field: "grandTotal",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.grandTotal}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.view ? (
                      <React.Fragment>
                        <BootstrapTooltip title="Quotation Detail">
                          <button
                            type="button"
                            onClick={() => {
                              history.push(
                                "/sales/quotation/quotation-detail/" +
                                  rowData.ID
                              );
                            }}
                            className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-list-alt"></i>
                          </button>
                        </BootstrapTooltip>
                        <BootstrapTooltip title="Quotation PrintOut">
                          <button
                            type="button"
                            onClick={() => {
                              setLeadQuotation(rowData);
                              setOpenQuotationPrint(true);
                            }}
                            className="btn btn-icon btn-label-info btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-print"></i>
                          </button>
                        </BootstrapTooltip>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Sales.png"
            guidance="You don't have any Quotations for this lead yet"
            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
              onClick={() => {
                history.push("/sales/quotation/quotation-list");
              }}
            >
              <i className="fas fa-map-marker-alt"></i>
              Go To Quotation
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openQuotationPrint}
        title="Quotation PrintOut"
        onCloseDialog={() => {
          setOpenQuotationPrint(false);
        }}
        maxWIdth="lg"
      >
        <CustomPrintOutQuotation quotationID={leadQuotation.ID} />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenQuotationPrint(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
};

export default LeadQuotations;
